import React from 'react';
// import NavigationHeader from '../../components/navigationHeader';
// import BreadCrumb from '../../components/breadCrumb';
// import {CopyRightsFooter} from '../../components/copyrights';
import { getApi, postUIlogs, postRecentSearch, getMetadatas } from "../../utils/event_handling";
import $ from 'jquery';
import Image from '../../components/image';

// import ErrorHandler from '../../components/error_500';
// import BasicPortlet from '../../components/basicPortlet';
import DiscoverForm from './discoverForm';
import { connect } from "react-redux";
import Autosuggest from 'react-autosuggest';
import './react-autosuggest.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
// import { faDatabase, faTag } from '@fortawesome/free-solid-svg-icons';
import { faExclamation, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import {
  addRecentHistory,
  storeDiscoverPageDataForDataSrc
} from "../../redux/actions";
import RcTooltip from 'rc-tooltip';
//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import { createBrowserHistory } from "history";
import { Scrollbars } from 'react-custom-scrollbars';
import { checkSessionForRedirection } from "../../utils/common_utils";
import { SKIP_SUGGESTION_RENDER } from "../../utils/constant";
// import {
//   normalizeAttributeName,
//   METADATA_MAP_KEY_SEPARATOR,
//   METADATA_MAP_VALUE_SEPARATOR,
//   normalizeChildDatasetName
// } from '../../utils/attribute_name_utils';
import { getLastProcessing } from "../../utils/dataProfileEventHandling";
import { logoutPageRedirect } from "../../utils/common_utils";
import { Modal } from 'react-bootstrap';
import { prefetchRecentHistory} from "../../utils/dataFetch";
import store from "../../redux/store";

const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];
var totalSearchList = 0;
const formatMultiSection = (searchStr, data) => {

  const inputValue = searchStr.trim().toLowerCase();
  let environment = data.filter(value => {
    return value.type === "Environment" && value.name.toLowerCase().includes(inputValue);
  });

  let datasource = data.filter(value => {
    return value.type === "Datasource" && value.name.toLowerCase().includes(inputValue);
  });



  let dataset = data.filter(value => {
    return value.type === "Dataset" && value.name.toLowerCase().includes(inputValue);
  });

  let attribute = data.filter(value => {
    return value.type === "Attribute" && value.name.toLowerCase().includes(inputValue);
  });

  let recentSearch = []
  if (searchStr.trim() === "") {
    recentSearch = data.filter(value => {
      return value.type === "Recent";
    });
  }



  let envObj = {
    type: "Environment",
    results: environment
  };

  let datasourceObj = {
    type: "Datasource",
    results: datasource
  };

  let datasetObj = {
    type: "Dataset",
    results: dataset
  };

  let attributeObj = {
    type: "Attribute",
    results: attribute
  };

  let recentSearchObj = {
    type: "Recent",
    results: recentSearch
  };

  let suggestions = [];

  if (recentSearchObj.results.length > 0) {
    suggestions.push(recentSearchObj);
  }

  //let envlen = envObj.results.length;

  if (envObj.results.length > 0) {
    suggestions.push(envObj);
  }

  if (datasourceObj.results.length > 0) {
    suggestions.push(datasourceObj);
  }

  if (datasetObj.results.length > 0) {
    suggestions.push(datasetObj);
  }

  if (attributeObj.results.length > 0) {
    suggestions.push(attributeObj);
  }

  totalSearchList = envObj.results.length + datasourceObj.results.length + datasetObj.results.length + attributeObj.results.length;
  return suggestions;
};


$("body").on("click", ".btn-clear", function () {
  $(".qd_search-box").removeClass("has-btn-close")
});

$("body").on("keyup", ".react-autosuggest__input", function () {
  if ($(this).val() !== "") {
    $(".qd_search-box").addClass("has-btn-close")

  } else {
    $(".qd_search-box").removeClass("has-btn-close")
    //$(".qd_search-box").removeClass("is-focused");
    $(".qd_search-box").removeClass("ad-filter-open");
    let countId = document.getElementById(".filter-count")
    if (!countId) {
      $("#btn-filter").removeClass("active");
    }
  }
  $(".filter-count").hide();
  $("#btn-filter").removeClass("active");
  $(".qd_search-box").removeClass("ad-filter-open");
  $(".qd_search-box").addClass("is-focused");

});

$(document).on("click", ".datalink", function (e) {
  if (document.getElementById($(this).attr("data-link")) !== null) {
    document.getElementById($(this).attr("data-link")).scrollIntoView();
  }
});


function shouldRenderSuggestions(value, reason) {
  if (SKIP_SUGGESTION_RENDER.includes(reason)) {
    return false;
  }

  return value.trim().length > 2;
}


function renderSuggestionsContainer({ containerProps, children, query }) {
  if (children === null && query === "") {
    return null;
  }

  if (children === null && query !== "") {
    return (<div {...containerProps}>
      <div className="row row-sm">
        {/* <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Environment</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div> */}
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Pipeline Integration</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Pipeline</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
        {/* <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Attribute</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div> */}
      </div>
    </div>)
  }

  // Children is not null. Query string is empty
  if (query.trim() === "") {
    let checkRecent = children[0].props.children[0].props.section.results.filter(x => x.type === "Recent")
    if (checkRecent.length === 0) {
      return ""
    }
  }

  // Children is not null. Query string is also not empty
  let recentFlag = "";
  // let environmentFlag = "";
  let datasourceFlag = "";
  let datasetFlag = "";
  // let attributeFlag = "";

  let environmentFlaglen = 0;
  let datasourceFlaglen = 0;
  let datasetFlaglen = 0;
  let attributeFlaglen = 0;

  let data = this.props.watchListMapping;
  children.map((item, i) => {

    if (item.props.children[0].props.section.results[0]['type'] === "Recent" && query.trim() === "") {
      recentFlag = i;
    }
    if (item.props.children[0].props.section.results[0]['type'] === "Environment") {
      // environmentFlag = i;
      environmentFlaglen = item.props.children[0].props.section.results.length;
      environmentFlaglen = environmentFlaglen > 6 ? 168 : 28 * environmentFlaglen
    }
    if (item.props.children[0].props.section.results[0]['type'] === "Datasource") {
      datasourceFlag = i;
      datasourceFlaglen = item.props.children[0].props.section.results.length;

      item.props.children[0].props.section.results.map((datasource)=>{
        if(data !== undefined ){
            Object.keys(data).map((uniqueKey) => {
                if (data[uniqueKey]['metadata_ids'].includes(datasource.id)) {
                  datasourceFlaglen = datasourceFlaglen + 1
                }
              return null;      
            }      
          );
        }
        return null;
      })
      
      datasourceFlaglen = datasourceFlaglen > 6 ? 168 : 28 * datasourceFlaglen
    }
    if (item.props.children[0].props.section.results[0]['type'] === "Dataset") {
      datasetFlag = i;
      datasetFlaglen = item.props.children[0].props.section.results.length;
      item.props.children[0].props.section.results.map((dataset)=>{
        if(data !== undefined ){
            Object.keys(data).map((uniqueKey) => {
                if (data[uniqueKey]['metadata_ids'].includes(dataset.id)) {
                  datasetFlaglen = datasetFlaglen + 1
                }
                return null
            });
        }
        return null
      })
      datasetFlaglen = datasetFlaglen > 6 ? 168 : 28 * datasetFlaglen

    }
    if (item.props.children[0].props.section.results[0]['type'] === "Attribute") {
      // attributeFlag = i;
      attributeFlaglen = item.props.children[0].props.section.results.length;
      attributeFlaglen = attributeFlaglen > 6 ? 168 : 28 * attributeFlaglen

    }
    return 1;
  }
  );
  $(".qd_search-box").removeClass("ad-filter-open");
  $(".qd_search-box").addClass("is-focused");


  return (
    <div {...containerProps}>
      <div className="row row-sm">
        {recentFlag !== "" && query === "" ? <div className="col-md-12">
          <h4 className="qd_autosuggest-title">Recent Searches:</h4>
          <div>{children[recentFlag]}</div>
        </div> : ""}
        {query !== "" ? <>
        
        {/* <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Environment</h4>
          {environmentFlag !== "" ? (
            <Scrollbars style={{ height: environmentFlaglen }} className="custom-scrollbar"
              autoHeightMin={0}
              autoHeightMax={200}
              thumbMinSize={30}
              universal={true}>
              <div style={{ paddingRight: 5 }}>{children[environmentFlag]}</div>
            </Scrollbars>
          ) : (
            <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
          )}
        </div> */}
          <div className="col-md-6">
            <hr className="d-block d-sm-none" />
            <h4 className="qd_autosuggest-title">Piepline Integration</h4>

            {datasourceFlag !== "" ? (
              <Scrollbars style={{ height: datasourceFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }} >{children[datasourceFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result">
                <FontAwesomeIcon icon={faExclamation} />
                No results were found</p>
            )}
          </div>

          <div className="col-md-6">
            <h4 className="qd_autosuggest-title">Pipeline</h4>
            {datasetFlag !== "" ? (
              <Scrollbars style={{ height: datasetFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }}>{children[datasetFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
            )}

          </div>
          {/* <div className="col-md-6">
            <hr />
            <h4 className="qd_autosuggest-title">Attribute</h4>

            {attributeFlag !== "" ? (
              <Scrollbars style={{ height: attributeFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }}>{children[attributeFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
            )}

          </div> */}
          <div className="col-md-12">
            <hr />
            <p className="search-result__count"><strong>{totalSearchList}</strong> Search Results</p>
          </div></> : ""}
      </div>

    </div>
  );

}



//const getSuggestions = (value,autoCompleteData) => {
//  const inputValue = value.trim().toLowerCase();
//  const inputLength = inputValue.length;
//
//  return inputLength === 0 ? [] : autoCompleteData.filter(lang =>
//    lang.name.toLowerCase().slice(0, inputLength) === inputValue
//  );
//};



const renderSectionTitle = section => {
  // return (
  //   // <div style={{ display: "flex", alignItems: "flex-end" }}>
  //   //   <div style={{ marginRight: 8 }}>
  //   //   </div>
  //   //   <strong style={{ color: "#1D2C4C" }}><b>{section.type}</b></strong>
  //   // </div>
  //   // <div>
  //   //   <h4>{section.type}</h4>
  //   // </div>
  // );

};



// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
//const renderSuggestion1 = suggestion => (
//  <div>
// {suggestion.name}
//  </div>
//);

const getSectionSuggestions = section => {
  return section.results;
};

let openflag = false;
$(document).on('click', function (e) {
  var container = $(".qd_search-filter-form");
  var btnfilter = $("#btn-filter");
  if ((!$(e.target).closest(container).length) && (!$(e.target).closest(btnfilter).length)) {
    $(".qd_search-filter-rst").removeClass("d-block")
    $(".qd_search-box").removeClass("ad-filter-open");
    var modelView = $(".react-autosuggest__suggestions-container--open")
    if (modelView.length === 0) {
      $(".qd_search-box").removeClass("is-focused");
    }
    if ($('.filter-count').css('display') === 'none') {
      $("#btn-filter").removeClass("active");
    }
    openflag = true;
  }
});

class AdvancedSearch extends React.Component {
  constructor(props) {
    super(props);
    this.getApi = getApi.bind(this);
    this.postUIlogs = postUIlogs.bind(this);
    this.postRecentSearch = postRecentSearch.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.changeCount = this.changeCount.bind(this);
    this.closeAdvancedFilter = this.closeAdvancedFilter.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.renderSuggestionsContainer = renderSuggestionsContainer.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.handleAdvancedFilter = this.handleAdvancedFilter.bind(this);
    this.convertData = this.convertData.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.getLastProcessing = getLastProcessing.bind(this);
    this.getMetadatas = getMetadatas.bind(this);
    let searchText = null;
    this.watchList = false
    this.state = {
      nestedData: {},
      newData: {},
      showTreeView: false,
      initialSelection: {},
      isSearchHappened: false,
      errorOccurred: false,
      autoCompleteData: [],
      subString: null,
      searchCount: 0,
      fullData: [],
      isFilterOpen: false,
      isNoResult: false,
      searchText: searchText,
      filteredData: [],
      isRedirect: false,
      value: searchText,
      suggestions: [],
      preSelectedEnv: null,
      preSelectedDataset: this.props.preSelectedDataset,
      preSelectedDatasource: this.props.preSelectedDatasource,
      preSelectedAttribute: null,
      envCount: null,
      datasourceCount: null,
      datasetCount: null,
      attributeCount: null,
      metaData: null,
      filterData: null,
      integration_details: null,
      search_text: "",
      selectedEnv: null,
      inputData: this.props.inputData,
      watchList : false
    }
  }

  closeAdvancedFilter(data) {
    this.setState({ isFilterOpen: false })
    openflag = false
    if (this.state.envCount === null) {
      $("#btn-filter").removeClass("active");
    }
    $(".qd_search-box").removeClass("ad-filter-open");

    this.props.handleCloseAutoCompleteModal(data);
  }

  handleAdvancedFilter() {
    let isFilterOpen = !this.state.isFilterOpen
    if (isFilterOpen || openflag) {
      this.setState({ value: null });
      if (openflag) {
        $(".qd_search-filter-rst").addClass("d-block")
        this.setState({ isFilterOpen: true })
        openflag = false
      } else {
        this.setState({ isFilterOpen: isFilterOpen })
      }
      $("#filter-count").hide();
      $("#btn-filter").addClass("active");
      $(".qd_search-box").addClass("ad-filter-open");
    } else {
      $(".qd_search-box").removeClass("ad-filter-open");
      this.setState({ isFilterOpen: false });

      if (this.state.envCount === null) {
        $("#btn-filter").removeClass("active");
      }


    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };


  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    //suggestions: getSuggestions(value,this.state.autoCompleteData)
    this.setState({
      suggestions: formatMultiSection(value, this.state.autoCompleteData)
    });

  };

  renderSuggestion(suggestion, { query }) {
    this.setState({ isFilterOpen: false })
    
    let integrationType = "default"
    if(suggestion.type === "Datasource"){
      integrationType = this.props.pipelineIconMapping[suggestion.id]
    }
    const suggestionText = suggestion.name;
    let uniqueKey = `${suggestion.envId}_${suggestion.datasourceId}_${suggestion.datasetId}_${suggestion.attributeId}`
    uniqueKey = uniqueKey.replace(undefined, "_")
    // let icon = '';
    let connectionIcon = '';
    let path = '';
    switch (suggestion.type) {
      case "Recent":
        // icon = '';
        break;
      // case "Environment":
      //   icon = faServer;
      //   connectionIcon = '';
      //   path = suggestion.name;
      //   break;
      case "Datasource":
        // icon = faDatabase;
        connectionIcon = suggestion.envName;
        path = suggestion.envName + "/" + suggestion.name;
        break;
      case "Dataset":
        // icon = faLayerGroup;
        connectionIcon = suggestion.datasourceName;
        path = suggestion.envName + "/" + suggestion.datasourceName + "/" + suggestion.name;
        break;
      case "Attribute":
        // icon = faTag;
        connectionIcon = suggestion.datasetName;
        path = suggestion.envName + "/" + suggestion.datasourceName + "/" + suggestion.datasetName + "/" + suggestion.name;
        break;
      default:
        // icon = '';
        connectionIcon = '';
        break;
    }

    // Handle recency section here and return corresponding component
    if (suggestion.type === "Recent") {
      return (
        <div className={"suggestion-content"}>
          <p className="qd_autosuggest-option">
            <FontAwesomeIcon icon={faClock} />&nbsp;
            {this.getHighlightedText(suggestionText, query)}
            <i className="icon-close" title="Close"></i>
          </p>
        </div>
      );
    }

    const renderTooltipText = (props) => (
      <span {...props}>
        {path}
      </span>
    );

    let data = this.props.watchListMapping;

    // let count = 0
    // Object.keys(data).some((uniqueKey)=>{
    //   if(data[uniqueKey]['metadata_ids'].includes(suggestion.id)){
    //     count++
    //   }
    // });

    return (
      <>
      <div data-link={uniqueKey} className="datalink"
        style={{ textDecoration: "none" }}>

        <div className={"qd_autosuggest-content"}>
          <div className="qd_autosuggest-option">
            <RcTooltip
              placement="top"
              overlay={renderTooltipText}
              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            >
              <div className="qd_autosuggest-option-inner">
                
                {suggestion.type === "Datasource"
                ?
                  <i class="tbl-tree__node-icon">
                    <Image src={`connector_icon_${integrationType}`} alt={"default"}/>                                      
                  </i>
                :
                  <i class="tbl-tree__node-icon">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60478 5.61891H6.65343V6.66062H3.97499C3.64348 6.66062 3.37318 6.9262 3.37318 7.25191V8.38001H2.35643C2.02146 8.38001 1.75 8.64784 1.75 8.97584V11.6542C1.75 11.9833 2.0226 12.25 2.35643 12.25H5.08138C5.41638 12.25 5.68772 11.9822 5.68887 11.6542V8.97584C5.68887 8.64672 5.41627 8.38001 5.08244 8.38001H4.06623V7.34156H9.93414V8.38H8.91752C8.58255 8.38 8.31109 8.64784 8.31109 8.97583V11.6542C8.31109 11.9833 8.58369 12.25 8.91752 12.25H11.6435C11.9785 12.25 12.25 11.9822 12.25 11.6542V8.97583C12.25 8.64672 11.9774 8.38 11.6435 8.38H10.6285V7.25191C10.6285 6.9262 10.3582 6.66062 10.0266 6.66062H7.34649V5.61891H8.39542C8.71191 5.61891 8.96962 5.36581 8.96846 5.05486V2.31406C8.96846 2.00308 8.71086 1.75 8.39437 1.75H5.60478C5.28827 1.75 5.03069 2.0031 5.03069 2.31406V5.05486C5.03069 5.36583 5.28829 5.61891 5.60478 5.61891Z" fill="currentColor" />
                    </svg>
                  </i>
                }
                
                {this.getHighlightedText(suggestionText, query)}
              </div>
            </RcTooltip>
          </div>


          {connectionIcon.length > 0
            ?
            <RcTooltip
              placement="top"
              overlay={connectionIcon}
              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            >
              <span><FontAwesomeIcon icon={faCodeBranch} />
                {connectionIcon}
              </span>
            </RcTooltip>
            : ''
          }
        </div>
      </div>
      <div className="qd-watchlist-group">
      {data && Object.keys(data).some(uniqueKey => data[uniqueKey]['metadata_ids'].includes(suggestion.id)) && (
        <>
          {/* {count > 3 &&
            <div className={`qd-watchlist-group__top ${isExpanded? "--is-expanded":""}`} onClick={this.toggleExpand}>
              <label>
                <i className="icon-toggle"></i>
                <i className='mr-1'>
                  <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor">
                    <path d="M330-490h300v-60H330v60Zm0-160h300v-60H330v60Zm447.23 498.23L627.92-345.85q-15.84-21.07-38.54-32.61Q566.69-390 540-390H180v-397.69Q180-818 201-839q21-21 51.31-21h455.38Q738-860 759-839q21 21 21 51.31v615.38q0 5.39-.69 10.46-.7 5.08-2.08 10.08ZM252.31-100Q222-100 201-121q-21-21-21-51.31V-330h360q12.31 0 22.73 5.46t17.96 15.39l154.54 202.3q-6.15 3.54-13.19 5.19Q715-100 707.69-100H252.31Z" />
                  </svg>
                </i>
                Watch list
              </label>
            </div>
          } */}
          <div className="qd-watchlist-group__content">
            <ul className="qd-watchlist">
              {Object.keys(data).map((uniqueKey) => {
                if (data[uniqueKey]['metadata_ids'].includes(suggestion.id)) {
                  return (
                    <li 
                        key={uniqueKey} 
                        onClick={()=>{
                                        this.setState({watchList:true})
                                        this.watchList = true
                                        this.props.handleWatchlistChange(data[uniqueKey]['watchlist_name'],data[uniqueKey]['watchlist_id'])
                                      }
                                }
                      >
                      <span>
                        <i className='mr-1'>
                          <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor">
                            <path d="M330-490h300v-60H330v60Zm0-160h300v-60H330v60Zm447.23 498.23L627.92-345.85q-15.84-21.07-38.54-32.61Q566.69-390 540-390H180v-397.69Q180-818 201-839q21-21 51.31-21h455.38Q738-860 759-839q21 21 21 51.31v615.38q0 5.39-.69 10.46-.7 5.08-2.08 10.08ZM252.31-100Q222-100 201-121q-21-21-21-51.31V-330h360q12.31 0 22.73 5.46t17.96 15.39l154.54 202.3q-6.15 3.54-13.19 5.19Q715-100 707.69-100H252.31Z" />
                          </svg>
                        </i>
                        {data[uniqueKey]['watchlist_name']}
                      </span>
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </div>
        </>
      )}
    </div>
    </>
    );

  }

  getHighlightedText(text, highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (parts.map((part, i) =>
      <span key={i}>
        {part.toLowerCase() === highlight.toLowerCase() ? <strong>{part}</strong> : part}
      </span>)
    );
  }

  changeCount(envCount, datasourceCount, datasetCount, attributeCount) {
    this.setState({
      envCount: envCount, datasourceCount: datasourceCount,
      datasetCount: datasetCount, attributeCount: attributeCount
    })
    openflag = true
  }


  applyFilter(type, envOption = null, datasourceOption = null, datasetOption = null, attributeOption = null) {
    let nestedData = _.cloneDeep(this.state.nestedData)
    let newData = {}
    let initialSelection = { "type": type }
    let envId = null
    let envName = null
    let datasourceId = null
    let datasourceName = null
    let datasetId = null
    let datasetName = null
    let attributeId = null
    let attributeName = null
    if (envOption !== null) {
      envId = envOption;
      envName = envOption.label;
      initialSelection["envId"] = envId
      initialSelection["envName"] = envName
      newData[envId] = nestedData[envId]
      if (type === "Environment") {
        newData[envId]["isShow"] = true
      }
      newData[envId]["isOpen"] = true
    }
    if (datasourceOption !== null) {
      datasourceId = datasourceOption.value;
      datasourceName = datasourceOption.label;
      initialSelection["datasourceId"] = datasourceId
      initialSelection["datasourceName"] = datasourceName
      if (type === "Datasource") {
        newData[envId]["childNodes"][datasourceId]["isShow"] = true
      }
      newData[envId]["childNodes"][datasourceId]["isOpen"] = true
    }
    if (datasetOption !== null) {
      datasetId = datasetOption.value;
      datasetName = datasetOption.label;
      initialSelection["datasetId"] = datasetId
      initialSelection["datasetName"] = datasetName
      if (type === "Dataset") {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
      }
      newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
    }
    if (attributeOption !== null) {
      attributeId = attributeOption.value;
      attributeName = attributeOption.label;
      initialSelection["attributeId"] = attributeId
      initialSelection["attributeName"] = attributeName
      newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
      newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isShow"] = true
    }

    this.setState({
      newData: newData,
      initialSelection: initialSelection,
      isSearchHappened: true, searchText: "",
      preSelectedAttribute: attributeOption, preSelectedDataset: datasetOption,
      preSelectedDatasource: datasourceOption, preSelectedEnv: envOption
    });
  }
  
  handleSelected = (event, data) => {
    let name = data.suggestion.name
    let type = data.suggestion.type    
    if (name === "") {
      return
    }
    let initialSelection = data.suggestion
    $(".qd_search-box").addClass("has-btn-close")
    if (type === "Recent") {
      return
    }
    $(".filter-count").hide();
    $("#filtericon").show();
    $("#btn-filter").removeClass("active");
    $(".qd_search-box").removeClass("is-focused");

    this.setState({
      isRedirect: false, preSelectedEnv: null, preSelectedDatasource: null,
      preSelectedDataset: null, preSelectedAttribute: null, envCount: null,
      datasourceCount: null, datasetCount: null, attributeCount: null, subString: null
    });

    // this.setState({ value: null });
    $(".qd_search-box").removeClass("has-btn-close")
    this.convertData(initialSelection, this.state.fullData, this.state.nestedData, name, false)

    this.props.handleCloseAutoCompleteModal(data.suggestion);

    if(this.watchList === false){
      this.props.handleWatchlistChange("ALL",null)
    }
    // this.props.renderSearchData(data.suggestion);
  }

  convertData(initialSelection, fullData, nestedData, searchText, isRedirect) {

    let filteredData = [];
    let searchCount = 0;
    let name;
    if (initialSelection === null) {
      filteredData = fullData.filter(x => (x.name.includes(searchText) && x.type !== "Recent"))
      searchCount = filteredData.length
      if (filteredData.length === 0) {
        this.setState({
          newData: {},
          isSearchHappened: true,
          isRedirect: isRedirect,
          isNoResult: true,
          searchText: searchText
        });
        return
      }
      initialSelection = filteredData[0]
      name = initialSelection["name"]
    } else {
      if (initialSelection.type === "Recent") {
        filteredData = fullData.filter(x => (x.name === searchText && x.type !== "Recent"))
        initialSelection = filteredData[0]
      } else {
        filteredData = fullData.filter(x => x.name === initialSelection.name && x.id === initialSelection.id && x.type === initialSelection.type)
      }
      name = searchText
    }
    if (initialSelection.type === "Datasource") {
      initialSelection["datasourceName"] = name
    } else if (initialSelection.type === "Dataset") {
      initialSelection["datasetName"] = name
    } else if (initialSelection.type === "Attribute") {
      initialSelection["attributeName"] = name
    } else if (initialSelection.type === "Environment") {
      initialSelection["envName"] = name
    }
    let newData = {}
    nestedData = _.cloneDeep(nestedData)

    for (let i = 0; i < filteredData.length; i++) {
      let data = filteredData[i]
      let type = data["type"]

      let envId = data["envId"]
      let datasourceId = data["datasourceId"]
      let datasetId = data["datasetId"]
      let attributeId = data["attributeId"]
      
      // if(attributeName !== undefined && attributeName !== null ){
      // } 
    this.props.getPipelineResponse("",this.props.isCheackedActiveRuns,"",{dataset_name: data.datasetName,datasource_name: data.datasourceName, datasourceId:data.datasourceId})

      // Trigger Left side panel tree.
      let id = "-left-panel-div-"
      if(type === "Datasource"){
        id  = "#" + type + id + datasourceId
        $(id).trigger("click");
      }
      else if(type === "Dataset"){
        id  = "#" + type + id + datasetId
        $(id).trigger("click");
      }
      else if( type === "Attribute"){
        id  = "#" + type + id + attributeId
        $(id).trigger("click");        
      }

      if (!Object.keys(newData).includes(envId)) {
        newData[envId] = nestedData[envId]
        if (type === "Environment" || isRedirect) {
          newData[envId]["isShow"] = true
        }
        newData[envId]["isOpen"] = true
      }

      if (datasourceId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["isOpen"] = true
        if (type === "Datasource" || isRedirect) {
          newData[envId]["childNodes"][datasourceId]["isShow"] = true
        }
      }

      if (datasetId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
        if (type === "Dataset" || isRedirect) {
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
        }
      }

      if (attributeId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isShow"] = true
      }
    }
    let recentHistory = this.props.dataModule.recentHistory
    if (!recentHistory.includes(name)) {
      let tab = "realtime"
      this.postRecentSearch(name, tab);
      recentHistory.push(name);
      fullData.push({ "type": "Recent", "name": name });
      this.props.addRecentHistory(recentHistory);
    }
    this.setState({ isRedirect: isRedirect, searchCount: searchCount });

    this.setState({
      newData: newData,
      initialSelection: initialSelection,
      isSearchHappened: true,
      isNoResult: false,
      filteredData: filteredData,
      fullData: fullData,
      searchText: searchText
    });

  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {

    this.setState({
      suggestions: [],
    });
  };
  // End Auto Complete

  componentDidMount() {
    let logoutPage = logoutPageRedirect()
    if (logoutPage) {
      return ''
    }
    let teamID = localStorage.getItem('team_id')
    let tenantData = { "tenant_id": teamID };

    this.getMetadatas();
    if (!this.props.dataModule.prefetchRecentHistory) {
          let searchTab = "discover"
          prefetchRecentHistory(tenantData, addRecentHistory, store, searchTab);
      }
    checkSessionForRedirection()
    this.getLastProcessing("getonlyprofiletime", "")
    this.getApi("integrations");
  }


  componentDidCatch(error, info) {
    this.setState({ errorOccurred: true });
    this.postUIlogs(error, info);
  }

  // After Optimization changes
  getData() {
    let metaData = this.state.metaData
    let nestedData = {}
    let fullData = []
    let recentSearchData = this.props.dataModule.recentHistory
    for (let i = 0; i < recentSearchData.length; i++) {
      fullData.push({ "type": "Recent", "name": recentSearchData[i] });
    }

    const envMap = {};
    const datasourceMap = {};
    const pipelineMap = {};

    if (this.props.inputData === undefined || this.props.inputData === null) {
      return null
    }
    let inputData = this.props.inputData
    // Build maps for efficient lookup
    if (inputData && inputData.pipelines) {
      // Build maps for efficient lookup

      inputData.integrations.forEach(ds => datasourceMap[ds.value] = { label: ds.label, envId: ds.env_id });
      inputData.pipelines.forEach(pipeline => pipelineMap[pipeline.value] = { label: pipeline.label, integrationId: pipeline.p_integration_id });

      // Process Pipelines
      inputData.pipelines.forEach(pipeline => {
        const datasourceData = datasourceMap[pipeline.p_integration_id];
        if (!datasourceData) {
          console.warn(`Datasource with ID ${pipeline.p_integration_id} not found.`);
          return; // Skip this pipeline if datasource is missing
        }

        const envId = datasourceData.envId;
        const datasourceId = pipeline.p_integration_id;
        const pipelineId = pipeline.value;
        const datasetId = pipeline.value;

        const envName = envMap[envId] || "Environment"; // Default to "Environment" if not found
        const datasourceName = datasourceData.label;
        const pipelineName = pipeline.label;
        // const pipelineType = pipeline.label;

        // Build fullData
        if (!fullData.some(item => item.envId === envId && item.type === "Environment")) {
          fullData.push({ name: envName, envId: envId, type: "Environment", id: envId });
        }
        if (!fullData.some(item => item.datasourceId === datasourceId && item.type === "Datasource")) {
          fullData.push({ name: datasourceName, envName: envName, id: datasourceId, datasourceId: datasourceId, type: "Datasource", envId: envId });
        }
        if (!fullData.some(item => item.pipelineId === pipelineId && item.type === "Pipeline")) {
          fullData.push({ name: pipelineName, id: pipelineId, datasetId : datasetId,  pipelineId: pipelineId, type: "Dataset", envId: envId, envName: envName, datasourceId: datasourceId, datasourceName: datasourceName });
        }

        // Build nestedData
        if (!nestedData[envId]) {
          nestedData[envId] = { title: envName, childNodes: {}, type: "Environment", id: envId };
        }
        if (!nestedData[envId].childNodes[datasourceId]) {
          nestedData[envId].childNodes[datasourceId] = { title: datasourceName, childNodes: {}, type: "Datasource", id: datasourceId };
        }
        if (!nestedData[envId].childNodes[datasourceId].childNodes[pipelineId]) {
          nestedData[envId].childNodes[datasourceId].childNodes[pipelineId] = { title: pipelineName, type: "Dataset", id: pipelineId, datasetId : datasetId, };
        }
      });
    } 
    else {
      console.warn("Input data structure not recognized.");
    }

    let searchText = this.state.searchText;
    let isRedirect = false
    let subString = null
    if (searchText !== undefined && searchText !== null && searchText !== "") {
      isRedirect = true
      subString = searchText
      this.convertData(null, fullData, nestedData, searchText, isRedirect)
      $(".qd_search-box").addClass("has-btn-close")
    }
    this.setState({
      nestedData: nestedData,
      autoCompleteData: fullData,
      fullData: fullData,
      subString: subString,
      metaData: metaData
    });
  }

  clearSearch() {
    $(".qd_search-box").removeClass("is-focused");
    this.setState({
      newData: {},
      searchText: "",
      subString: "", 
      value: "",
      isNoResult: false,
      searchCount: 0, isRedirect: false, isSearchHappened: false, initialSelection: {}
    })
  }

  handleSearchChange = (event) => {
    let search_text = event.target.value.toLowerCase();
    this.setState({ search_text: search_text });

    let filteredEnv = this.state.filterData.environmentOptions.filter(env =>
      env.label.toLowerCase().includes(search_text)
    );

    this.setState({ filteredEnv: filteredEnv });
  };
  
  handleSelect = (env, index, latest_env_name) => {
    this.setState({
      selectedEnv: { ...env, color: env.label === latest_env_name ? '#4ca3ff' : colors[index % colors.length], },
    });
  };


  render() {
    let logoutPage = logoutPageRedirect()
    if (logoutPage) {
      return ''
    }
    
    let { value, suggestions } = this.state;


    let placeholder = 'Search for any thing! Just start typing...'
    
    if(this.props.preSelectedDataset !== null && this.props.preSelectedDataset !== undefined && value === null){
      placeholder = this.props.preSelectedDataset["label"]
      value = this.props.preSelectedDataset["label"]
    }
    else if(this.props.preSelectedDatasource !== null && this.props.preSelectedDatasource !== undefined && value === null){
      placeholder = this.props.preSelectedDatasource["label"]
      value = this.props.preSelectedDatasource["label"]
    }

    // Autosuggest will pass through all these props to the input.
    let inputProps = {
      placeholder: placeholder,
 value: value || '',
       onChange: this.onChange,
    };


    const latestIntegration = this.state.integration_details !== null &&
      Object.values(this.state.integration_details)
        .sort((a, b) => new Date(b.created_time) - new Date(a.created_time))[0];

    const latest_env_name = latestIntegration?.env_name;
    // const latest_env_id = latestIntegration?.env_id;

    return (

      <Modal show={this.props.autocompletemodal} size="lg" className="modal_search-autocomplete" onHide={this.props.handleCloseAutoCompleteModal}>
        <Modal.Body className="p-0">
          <div className="qd_search-container">
            <div className="qd_search-box autocomplete">
              <Autosuggest
                multiSection={true}
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
                alwaysRenderSuggestions={value !== null && value.trim() === "" ? true : false}
                renderSectionTitle={renderSectionTitle}
                getSectionSuggestions={getSectionSuggestions}
                onSuggestionSelected={this.handleSelected}
                highlightFirstSuggestion={true}
                shouldRenderSuggestions={shouldRenderSuggestions}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getPipelineResponse = {this.props.getPipelineResponse}

              />
              {this.state.value !== null && this.state.value.trim() !== "" ? <button className="btn btn-clear" title="Clear" onClick={this.clearSearch}><i className="icon-close"></i></button> : ""}
              <div className="qd_search-bar-divider">
                <span>or</span>
              </div>
              <div className="qd-filtered_button">
                <button onClick={this.handleAdvancedFilter} id="btn-filter" className="btn btn-light-secondary">
                  <i id="filtericon"><svg xmlns="http://www.w3.org/2000/svg" fill="#0021a5" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg></i>
                  <span className="filter-count" style={{ display: "none" }}>3</span><span>Filters</span>
                </button>
              </div>
            </div>
            <div className={this.state.isFilterOpen ? "qd_search-filter-rst d-block" : "qd_search-filter-rst d-block"} data-select2-id="29">
              {this.state.isFilterOpen ?
                <DiscoverForm nestedData={this.state.nestedData}
                  applyFilter={this.applyFilter}
                  changeCount={this.changeCount}
                  closeAdvancedFilter={this.closeAdvancedFilter}
                  filterResultData={this.state.autoCompleteData}
                  preSelectedEnv={this.state.preSelectedEnv}
                  preSelectedDataset = {this.props.preSelectedDataset}
                  preSelectedDatasource = {this.props.preSelectedDatasource}
                  envCount={this.state.envCount} datasourceCount={this.props.preSelectedDatasource !== undefined && this.props.preSelectedDatasource !== null && Object.keys(this.props.preSelectedDatasource).length}
                  datasetCount={this.props.preSelectedDataset !== undefined && this.props.preSelectedDataset !== null && Object.keys(this.props.preSelectedDataset).length} attributeCount={this.state.attributeCount}
                  preSelectedAttribute={this.state.preSelectedAttribute}
                  selectedEnv={this.state.selectedEnv}
                  latest_env_name={latest_env_name}
                  latest_env_id={this.props.selectedEnvId}
                  handleCloseAutoCompleteModal = {this.props.handleCloseAutoCompleteModal}
                  renderSearchData = {this.props.renderSearchData}
                  getPipelineResponse = {this.props.getPipelineResponse}
                /> : ""}
            </div>
            <input type="hidden" id="zoomlevel" />
          </div>
          {/* </div>
            </div>
          </div> */}
        </Modal.Body>
      </Modal>

    );
  }
}


const mapStateToProps = state => {
  return state;
}

export default connect(mapStateToProps, {
  addRecentHistory,
  // fetchLastRefreshOfDatasets,
  storeDiscoverPageDataForDataSrc,
})(AdvancedSearch);
